import { Appointment } from "@elixir/types";
import {
  cancelAppointmentReminders,
  updateAppointment,
} from "../../utils/bridges/methods";
import { ControllerReturnType } from "../types";
import {
  AptActivityType,
  trackAppointmentActivity,
} from "./appointment-activity";

export default async function archiveAppointment({
  appointment,
}: {
  appointment: Pick<Appointment, "aid">;
}): Promise<ControllerReturnType> {
  try {
    const { aid } = appointment;
    await updateAppointment({ data: { archive: true }, aid });

    cancelAppointmentReminders({ aid });
    trackAppointmentActivity({ aid, activity: AptActivityType.VISIT_ARCHIVED });
    return { success: true };
  } catch (e) {
    console.error(e);
    return { success: false };
  }
}
